<form
  [formGroup]="formGroup"
  [iqForm]="formGroup"
  (ngSubmit)="submit($event)"
  novalidate
  autocomplete="off"
>
  <iq-error-message *ngIf="errorMessage" [errorMessage]="errorMessage">
  </iq-error-message>
  <section
    *ngIf="singleSelectionItem && singleSelectionItem.options.length > 0"
    class="list-container"
  >
    <div class="line-item" *ngFor="let option of singleSelectionItem.options">
      <label for="{{ option.label }}">{{ option.label }}</label>
      <iq-radio-input
        ><input
          id="{{ option.label }}"
          type="radio"
          iqInput
          name="itemRadio"
          [formControl]="selectedOption"
          [value]="option.value"
      /></iq-radio-input>
    </div>
  </section>
  <ng-content> </ng-content>
</form>
